export { SharedModule } from './shared.module';